"use strict";

import React from "react";

import { RgbaStringColorPicker } from "react-colorful";
import { useState } from "react";
import "./colorpicker.css";

const ColorPicker = (props) => {
  const { changeData, subNumber, type, defaultColor } = props;
  // const { handleChangeValue, row, type, data } = props;
  // const [color, setColor] = useState(defaultColor);
  const hanldeSetColor = (value) => {
    changeData(subNumber, type, value);
  };
  return <RgbaStringColorPicker color={defaultColor} onChange={hanldeSetColor} />;
};
export default ColorPicker;
